module.exports = __webpack_public_path__ + "img/NU.2c044d67.png";